{
    "IncludeendedonholdLabel": "Inclure la fin de l'attente :",
    "UnreturnedCalls_SectionHeader": "Appels non retournés",
    "UnreturnedCalls_SectionPara": "Vous pouvez choisir si les appels terminés en attente sont considérés comme abandonnés dans les rapports \"Appels perdus non retournés\" ainsi que dans la statistique \"Appels non retournés\".",
    "NAME": "UnreturnedCalls",
    "IncludeescapedLabel": "Inclure Échappé :"
}